<template>
    <div class="container">
        <div class="header-swiper">
            <div class="swiper-container current-wrap">
                <div class="swiper-wrapper">
                    <div v-for="item in swiperList" :key="item" class="swiper-slide">
                        <img :src="item">
                    </div>
                </div>
                <div class="swiper-pagination current-pagination" />
            </div>
        </div>
        <div class="title-view">
            <div class="icon">
                <span>1</span>
            </div>
            <img class="bgd-img" :src="titleBgdList[0]">
            <div class="text">拉勾Java课程适合什么人学习</div>
        </div>
        <div class="section-1">
            <img class="img" :src="imgList[0]">
        </div>
        <button class="btn-1 btns" @click="toApply">
            <img :src="btnList[0]">
        </button>
        <div class="title-view">
            <div class="icon">
                <span>2</span>
            </div>
            <img class="bgd-img" :src="titleBgdList[1]">
            <div class="text">拉勾教育培养符合企业要求的优秀工程师</div>
        </div>
        <div class="section-2">
            <div class="center">架构师必备9大能力</div>
            <div class="left-1 left boxs">
                <div class="box">源码剖析和框架定制能力</div>
                <div class="img"><img class="left-icon" :src="icon"></div>
            </div>
            <div class="left-2 left boxs">
                <div class="box">分布式/微服务架构设计能力</div>
                <div class="img"><img class="left-icon" :src="icon"></div>
            </div>
            <div class="left-3 left boxs">
                <div class="box">容器技术和DevOps能力</div>
                <div class="img"><img class="left-icon" :src="icon"></div>
            </div>
            <div class="left-4 left boxs">
                <div class="box">高并发/高可用业务场景解决方案能力</div>
                <div class="img"><img class="left-icon" :src="icon"></div>
            </div>
            <div class="left-5 left boxs">
                <div class="box">海量数据存储/分布式缓存实战能力</div>
                <div class="img"><img class="left-icon" :src="icon"></div>
            </div>
            <div class="right-1 right boxs">
                <img class="right-icon" :src="icon">
                <div class="box">海量数据搜索和实时计算能力</div>
            </div>
            <div class="right-2 right boxs">
                <img class="right-icon" :src="icon">
                <div class="box">分布式消息中间件实战能力</div>
            </div>
            <div class="right-3 right boxs">
                <img class="right-icon" :src="icon">
                <div class="box">平台性能力分析和调优能力</div>
            </div>
            <div class="right-4 right boxs">
                <img class="right-icon" :src="icon">
                <div class="box">算法与底层调优能力</div>
            </div>
        </div>
        <div class="section-main">
            <div class="title-view">
                <div class="icon">
                    <span>3</span>
                </div>
                <img class="bgd-img" :src="titleBgdList[2]">
                <div class="text text-f">关于拉勾教育</div>
            </div>
            <div class="main">
                <div class="left">
                    <div class="top">
                        <img class="img-up" src="https://s20.lgstatic.com/growth/activity/20210630/1625043936837.png" alt="">
                        <span>拉勾教育介绍</span>
                        <img class="img-down" src="https://s20.lgstatic.com/growth/activity/20210630/1625043945385.png" alt="">
                    </div>
                    <div class="text">
                        <div>拉勾是国内唯一一家做互联网领域垂直招聘的平台在做线上教育，有90万+互联网企业资源，跟128家一线大厂联合推出训练营课程。</div>
                        <div style="padding-top:30PX">基于独有的出口优势，拉勾教育打通了「人才培养+人才输送的闭环」，致力于打造「真正有就业保障的IT在线职业教育平台」，帮助互联网人快速成长，实现升职加薪。</div>
                    </div>
                </div>
                <img class="right-img" src="https://s20.lgstatic.com/growth/activity/20210630/1625044494156.png">
                <div class="right">
                    <div class="r-l">企业反馈</div>
                    <div class="r-text">
                        <div class="r-t">周期短</div>
                        <div class="r-t">面试通过率高</div>
                        <div class="r-t">缩短入职周期</div>
                    </div>
                </div>
            </div>
            <div class="c-main">
                <div class="title">
                    <img class="img-up" src="https://s20.lgstatic.com/growth/activity/20210630/1625043936837.png" alt="">
                    <span>社会荣誉</span>
                    <img class="img-down" src="https://s20.lgstatic.com/growth/activity/20210630/1625043945385.png" alt="">
                </div>
                <div class="c-m">
                    <div class="item">
                        <img class="img" src="https://s20.lgstatic.com/growth/activity/20210701/1625106728376.png">
                        <div class="text">
                            <img class="icon" src="https://s20.lgstatic.com/growth/activity/20210701/1625108256125.png">
                            <span>2020中国在线教育 <span class="tips">优秀内容十强</span></span>
                        </div>
                    </div>

                    <div class="item">
                        <img class="img" src="https://s20.lgstatic.com/growth/activity/20210701/1625108578941.png">
                        <div class="text">
                            <img class="icon" src="https://s20.lgstatic.com/growth/activity/20210701/1625108256125.png">
                            <span>2020中国在线教育 <span class="tips">最具投资价值十强</span></span>
                        </div>
                    </div>

                    <div class="item">
                        <img class="img" src="https://s21.lgstatic.com/growth/activity/20210701/1625108592444.png">
                        <div class="text">
                            <img class="icon" src="https://s20.lgstatic.com/growth/activity/20210701/1625108256125.png">
                            <span>2020中国在线教育 <span class="tips"> 独角兽TOP20</span></span>
                        </div>
                    </div>

                    <div class="item">
                        <img class="img" src="https://s21.lgstatic.com/growth/activity/20210701/1625108604123.png">
                        <div class="text">
                            <img class="icon" src="https://s20.lgstatic.com/growth/activity/20210701/1625108256125.png">
                            <span>2020中国在线教育 <span class="tips">会员单位</span></span>
                        </div>
                    </div>
                </div>
            </div>
            <button class="btn-1 btns b-main" @click="toApply">
                <img :src="btnList[1]">
            </button>
        </div>
        <div class="title-view">
            <div class="icon">
                <span>4</span>
            </div>
            <img class="bgd-img" :src="titleBgdList[3]">
            <div class="text">一线大厂用人需求</div>
        </div>
        <div class="section-sw1">
            <div class="swiper-container current-wraps">
                <div class="swiper-wrapper">
                    <div v-for="item in pcSwiperList1" :key="item" class="swiper-slide">
                        <img :src="item" >
                    </div>
                </div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
        <div class="title-view">
            <div class="icon">
                <span>5</span>
            </div>
            <img class="bgd-img" :src="titleBgdList[4]">
            <div class="text">12阶段课程大纲全新升级</div>
        </div>
        <div class="section-5">
            <div class="title">
                结合拉勾招聘最新《互联网招聘白皮书》升级课程
            </div>
            <div class="main">
                <el-tabs v-model="activeName" @tab-click="changeTab">
                    <el-tab-pane class="main-tab"
                        v-for="(value, inde) in phaseList" :key="inde" 
                        :label="value.phaseTitle" :name="inde"
                    >
                        <div class="m">
                            <div class="m-title">
                                {{value.phaseDesi}}
                            </div>
                            <div class="main-icon"/>
                            <div class="m-flex">
                                <div class="left">
                                    <div class="m-t">学习目标</div>
                                    <div class="m-t-icon" />
                                    <div class="item" v-for="(v, i) in value.phaseTargetList" :key="i" >{{v}}</div>
                                </div>
                                <div class="right">
                                    <div class="m-t">关键技术点</div>
                                    <div class="m-t-icon" />
                                    <div class="item" v-for="(v, i) in value.skillsList" :key="i" >{{v}}</div>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <div class="jumpFnbox">
                    <button class="jumpFn" @click="toApply">
                        <img :src="btnList[2]">
                        <span>获取完整课程大纲</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="title-view">
            <div class="icon">
                <span>6</span>
            </div>
            <img class="bgd-img" :src="titleBgdList[5]">
            <div class="text">8大复合场景学习方式 让学习变得轻松</div>
        </div>
        <div class="section-6">
            <div class="text t1">线上授课</div>
            <div class="text t2">实践拓展</div>
            <div class="text t3">全程伴读</div>
            <div class="text t4">源码开放</div>
            <div class="text t5">独家资料</div>
            <div class="text t6">定期测评</div>
            <div class="text t7">模拟面试</div>
            <div class="text t8">大厂内推</div>
        </div>
        <div class="title-view">
            <div class="icon">
                <span>7</span>
            </div>
            <img class="bgd-img" :src="titleBgdList[6]">
            <div class="text">Java大项目贯穿-实战式教学</div>
        </div>
        <div class="section-7">
            <div class="swiper-container sw-wrap">
                <div class="swiper-wrapper">
                    <div v-for="item in pcSwiperList2" :key="item" class="swiper-slide">
                        <img :src="item" >
                    </div>
                </div>
                <div class="swiper-pagination sw-pagination" />
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
        <div class="title-view">
            <div class="icon">
                <span>8</span>
            </div>
            <img class="bgd-img" :src="titleBgdList[7]">
            <div class="text">拉勾教育Java课程核心优势</div>
        </div>
        <div class="section-8">
            <div class="left">
                <div class="title t1">
                    学习效果有保障，服务体验佳
                </div>
                <div class="main">
                    <div class="m-t">
                        实用的实战课程
                    </div>
                    <div class="m-desc">
                        深耕互联网招聘行业8年，从企业用人需求出发，结合百位大厂技术专家意见，打造实用且紧跟技术趋势的实战课程。
                    </div>

                    <div class="m-t">
                        优质的讲师团队
                    </div>
                    <div class="m-desc">
                        由互联网大厂的CTO、技术专家、架构师、授课名师组成，技术经验和授课经验丰富，确保学员当场吸收。
                    </div>

                    <div class="m-t">
                        保障学习效果
                    </div>
                    <div class="m-desc">
                        闯关式学习、“四对一”专人督促指导，学、练、测、评结合，保障学习效果。
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="title t2">
                    独有的企业资源，保障就业
                </div>
                <div class="main">
                    <div class="m-t">
                        拉勾猎头求职指导
                    </div>
                    <div class="m-desc">
                        百人猎头服务团队提供专业的简历诊断与求职指导，面试前1V1辅导，面试后1V1复盘。
                    </div>

                    <div class="m-t">
                        品牌影响力强
                    </div>
                    <div class="m-desc">
                        拉勾招聘已有的业内口碑与美誉积累，带来了一定的品牌影响力，并广受优质的企业青睐。
                    </div>

                    <div class="m-t">
                        平台资源丰富
                    </div>
                    <div class="m-desc">
                        依托拉勾招聘与前程无忧的招聘平台资源，拥有精准的人才画像，丰富的人才出口资源，平台上活跃着百度、阿里、腾讯、字节跳动、美团点评等90多万家优秀互联网公司。
                    </div>
                </div>
            </div>
        </div>
        <div class="title-view">
            <div class="icon">
                <span>9</span>
            </div>
            <img class="bgd-img" :src="titleBgdList[8]">
            <div class="text">拉勾教育2020年 往期毕业学员offer榜单</div>
        </div>
        <div class="section-9">
            <div class="r-main">
                <div class="swiper-container range_list">
                    <div class="swiper-wrapper">
                        <div
                            v-for="(value,inde) in rankList"
                            :key="inde"
                            class="swiper-slide range_box"
                        >
                            <div class="company">
                                <img class="company-img" :src="value.companyLogo"/>
                            </div>
                            <div class="name">{{value.name}}</div>
                            <div class="range">{{value.education}}</div>
                            <div class="course_name">{{value.change}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section-10">
            <div class="title-view">
                <div class="icon">
                    <span>10</span>
                </div>
                <img class="bgd-img" :src="titleBgdList[9]">
                <div class="text text-f">入学签订协议 学习有保障</div>
            </div>
            <img class="img" :src="imgList[1]">
        </div>
        <div class="footer">
            <button class="footer-btn" @click="toForm">
                <div class="text">【7天免费试听】和详细【Java学习计划】</div>
                <div class="i-bs">
                    <div class="img-box">
                        <img :src="btnList[2]">
                        <span class="i_t">立即申请</span>
                    </div>
                </div>
            </button>
        </div>
        <!-- 侧边导航栏 -->
        <LaunchNav :active-tab="0" />
    </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import { handleJumpUrl } from '../../../uitl/getParam.js';
import LaunchNav from '../../../components/LaunchNav/index';
import List from './list'
export default {
    components: {
        LaunchNav
    },
    data() {
        return {
            List,
            imgList:[],
            swiperList:[],
            titleBgdList:[],
            btnList:[],
            pcSwiperList1:[],
            pcSwiperList2:[],
            icon:"https://s21.lgstatic.com/growth/activity/20210630/1625038818565.png",
            activeName: "0",
            phaseList:[],
            rankList:[],
        };
    },
    mounted() {
        let dataList = this.List.data.pc
        this.imgList = dataList.imgList
        this.swiperList = dataList.swiperList
        this.titleBgdList = dataList.titleBgdList
        this.btnList = dataList.btnList
        this.pcSwiperList1 = dataList.pcSwiperList1
        this.pcSwiperList2 = dataList.pcSwiperList2
        this.phaseList = dataList.phaseList
        this.rankList = dataList.rankList
        
        this.swiperInit()
        this.renderSwiper()
        this.rangeSwipers()
    },
    methods: {
        rangeSwipers() {
            let option = {
                direction: 'vertical',
                loop: true,
                autoplay: 1,
                speed: 850,
                freeMode:true,
                autoplayDisableOnInteraction: false,
                slidesPerView: 6
            };
            this.$nextTick(() => {
                const swiperDom = new Swiper('.range_list', option);
            })
        },
        swiperInit() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                autoplayDisableOnInteraction: false,
                autoplay: 3000,
                pagination: '.current-pagination',
                paginationClickable: true,
                spaceBetween: 30
            };
            let option1 = {
                direction: 'horizontal',
                loop: true,
                speed: 500,
                autoplayDisableOnInteraction: false,
                autoplay: 3000,
                pagination: '.sw-pagination',
                paginationClickable: true,
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                spaceBetween: 30
            };
            this.$nextTick(() => {
                const swiper1 = new Swiper('.current-wrap', option);
                const swiper2 = new Swiper('.sw-wrap', option1);
            });
        },
        toApply() {
            window.open('https://tb.53kf.com/code/client/90d3e270b5d355aa44bafe74fd7fe8a11/2');
        },
        toForm() {
            window.open('https://kaiwu.lagou.com/crmForm/form/f90208644f3843e992565f3621197b83?')
        },
        renderSwiper() {
            setTimeout(() => {
                let modify = 0;
                let translate = 0;
                let scale = 0;
                const swiper = new Swiper('.current-wraps', {
                    autoplay: 3000,
                    loop: true,
                    slidesPerView: 'auto',
                    loopedSlides: 4,
                    pagination: '.current-pagination',
                    paginationClickable: true,
                    watchSlidesProgress: true,
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next',
                    centeredSlides: true,
                    onSetTransition: (swiper, transition) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                });
                swiper.on('progress', () => {
                    for (let i = 0; i < swiper.slides.length; i++) {
                        let slide = swiper.slides.eq(i);
                        let slideProgress = swiper.slides[i].progress;
                        modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        translate = slideProgress * modify * 500 + 'PX';
                        scale = 1 - Math.abs(slideProgress) / 5;
                        let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                    }
                });
            }, 500);
        },
    }
}
</script>

<style lang="less" scoped>
.container {
    overflow-y: scroll;
    overflow-x: hidden;
    width: 100%;
    background: #E9F2F1;
    padding-bottom: 130PX;
    .section {
        position: relative;
        width: 100%;
        .img {
            width: 100%;
            display: block;
        }
    }
}
.section-1 {
    margin: 0 auto;
    width: 1232PX;
    .img {
        width: 100%;
        display: block;
    }
}
.header-swiper {
    width: 100%;
    /deep/ .current-wrap {
        width: 100%;
        min-width: 1200PX;
        .swiper-wrapper {
            width: 100%;
            .swiper-slide {
                width: 100%;
                img {
                    width: 100%;
                }
            }
        }
        .swiper-pagination-bullet{
            width: 10PX;
            height: 10PX;
            background: #fff;
            border-radius: 50%;
            opacity: .62;
            &-active{
                border-radius: 12PX;
                width: 28PX;
                background: #fff;
                opacity: 1;
            }
        }
    }
}
.title-view {
    width: 100%;
    position: relative;
    margin: 80PX auto 50PX;
    min-width: 1200PX;
    .icon {
        position: relative;
        margin: 0 auto 8PX;
        width: 130PX;
        height: 150PX;
        background: url('https://s20.lgstatic.com/growth/activity/20210630/1625034897243.png') center no-repeat;
        background-size: 100% 100%;
        font-size: 52PX;
        color: #fff;
        font-weight: 600;
        text-align: center;
        span {
            position: absolute;
            left: 50%;
            font-family: 'SourceHanSansCN-Bold', 'SourceHanSansCN';
            transform: translate(-50%);
            bottom: 16PX;
        }
    }
    .bgd-img {
        display: block;
        margin: 0 auto;
        height: 66PX;
    }
    .text {
        margin-top: -40PX;
        text-align: center;
        font-size: 42PX;
        color: #232323;
        font-weight: 800;
        text-align: center;
        font-family: 'SourceHanSansCN-Heavy', 'SourceHanSansCN';
    }
    .text-f {
        color: #fff;
    }
}
.btns {
    display: block;
    margin: 0 auto;
    background-color:transparent;
    border: none;
    z-index: 9;
    transition: all 0.6s;    //设置动画执行的时间为0.6s
    cursor: pointer;
    &:hover {
        transform: scale(1.05);
    }
}
.btn-1 {
    width: 400PX;
    height: 86PX;
    margin-top: 26PX;
    img {
        width: 100%;
        display: block;
    }
}
.section-2 {
    width: 1200PX;
    height: 480PX;
    margin: 0 auto;
    position: relative;
    .center {
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        top: 0;
        width: 136PX;
        height: 480PX;
        border-radius: 30PX;
        background: linear-gradient(173deg, #E9CF9D 0%, #9E855D 100%);
        box-sizing: border-box;
        font-size: 36PX;
        color: #fff;
        padding: 50PX;
        text-align: center;
        font-weight: 500;
        line-height: 42PX;
    }
    .boxs {
        width: 508PX;
        height: 55PX;
        position: absolute;
        .box {
            width: 418PX;
            height: 55PX;
            background: linear-gradient(180deg, #E9CF9D 0%, #9E855D 100%);
            border-radius: 14PX;
            text-align: center;
            line-height: 55PX;
            color: #fff;
            font-size: 24PX;
            font-family: 'SourceHanSansCN-Bold', 'SourceHanSansCN';
            text-shadow: 0px 2px 4px #A99067;
        }
    }
    .left {
        left: 10PX;
        .img {
            position: absolute;
            right: 0PX;
            top: 50%;
            transform: translateY(-50%);
        }
        .left-icon {
            transform: rotate(180deg);
            width: 87PX;
            height: 15PX;
        }
    }
    .left-1 {
        top: 30PX;
    }
    .left-2 {
        top: 125PX;
    }
    .left-3 {
        top: 221PX;
    }
    .left-4 {
        top: 316PX;
    }
    .left-5 {
        top: 411PX;
    }
    .right {
        right: 10PX;
        display: flex;
        align-items: center;
        .right-icon {

            width: 87PX;
            height: 15PX;
        }
    }
    .right-1 {
        top: 34PX;
    }
    .right-2 {
        top: 151PX;
    }
    .right-3 {
        top: 268PX;
    }
    .right-4 {
        top: 385PX;
    }
}
.section-main {
    overflow-x: hidden;
    width: 101%;
    margin-top: -60PX;
    background: url('https://s20.lgstatic.com/growth/activity/20210701/1625105865513.png') no-repeat center;
    background-size: 100% 100%;
    margin-left: -4PX;
    padding-top: 220PX;
    min-width: 1200PX;
    padding-bottom: 150PX;
    .main {
        position: relative;
        margin: 0 auto 40PX;
        width: 1180PX;
        height: 600PX;
        overflow: hidden;
        .left {
            width: 433PX;
            height: 498PX;
            background: linear-gradient(180deg, #FFFFFF 0%, #EBEBEB 100%);
            border-radius: 12PX;
            margin-top: 34PX;
            margin-left: 40PX;
            .top {
                width: 100%;
                height: 110PX;
                background: linear-gradient(136deg, #22D6B6 0%, #097A66 100%);
                border-radius: 13PX 13PX 0PX 0PX;
                line-height: 110PX;
                text-align: center;
                .img-up {
                    width: 33PX;
                    height: 20PX;
                }
                span {
                    color: #fff;
                    font-size: 28PX;
                    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
                    font-weight: bold;
                    padding: 0 16PX;          
                }
                .img-down {
                    width: 33PX;
                    height: 20PX;
                }
            }
            .text {
                font-size: 18PX;
                font-family: SourceHanSansCN-Regular, SourceHanSansCN;
                font-weight: 400;
                color: #333333;
                box-sizing: border-box;
                padding: 60PX 25PX 0PX 36PX;
                line-height: 34PX;
            }
        }
        .right-img {
            position: absolute;
            right: 180PX;
            top: 0PX;
            width: 378PX;
        }
        .right {
            position: absolute;
            top: 0;
            right: 50PX;
            width: 228PX;
            height: 180PX;
            background: #FFF9ED;
            border-radius: 22PX;
            display: flex;
            .r-l {
                width: 53PX;
                height: 180PX;
                background: linear-gradient(173deg, #E9CF9D 0%, #9E855D 100%);
                border-radius: 22PX 0 0 22PX;
                font-size: 26PX;
                color: #fff;
                font-family: Helvetica;
                text-align: center;
                box-sizing: border-box;
                padding: 30PX 12PX 0PX 16PX;
                line-height: 30PX;
            }
            .r-text {
                flex: 1;
                .r-t {
                    position: relative;
                    font-size: 22PX;
                    color: #595959;
                    font-family: Helvetica;
                    padding: 14PX;
                    padding-left: 22PX;
                    &::before {
                        width: 6PX;
                        height: 6PX;
                        content: '';
                        display: inline-block;
                        border-radius: 50%;
                        background: #595959;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        left: 8PX;
                    }
                }
            }
        }
    }
    .c-main {
        width: 1135PX;
        position: relative;
        margin: 0 auto;
        .title {
            width: 100%;
            text-align: center;
            .img-up {
                width: 33PX;
                height: 20PX;
            }
            span {
                color: #fff;
                font-size: 28PX;
                font-family: SourceHanSansCN-Bold, SourceHanSansCN;
                font-weight: bold;
                padding: 0 16PX;          
            }
            .img-down {
                width: 33PX;
                height: 20PX;
            }
        }
        .c-m {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
        }
        .item {
            width: 532PX;
            margin-top: 68PX;
            .img {
                width: 100%;
                display: block;
            }
            .text {
                text-align: center;
                padding-top: 30PX;
                .icon {
                    width: 25PX;
                    height: 19PX;
                }
                span {
                    padding-left: 12PX;
                    font-size: 26PX;
                    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
                    font-weight: bold;
                    color: #FFFFFF;
                    .tips {
                        color: #FCEDAF;
                    }
                }
            }

        }
        .item:nth-child(1) {
            margin-right: 70PX;
        }
        .item:nth-child(3) {
            margin-right: 70PX;
        }
    }
    .b-main {
        margin: 80PX auto 0;
    }
}
.section-sw1 {
    position: relative;
    width: 100%;
    min-width: 1200PX;
    margin: 20PX 0 40PX;
    /deep/ .current-wraps {
        width: 1060PX;
        height: 600PX;
        .swiper-slide {
            width: 680PX;
            opacity: 0;
            img {
                display: block;
                width: 680PX;
                margin: 0 auto;
            }
            &.swiper-slide-active {
                opacity: 1;
            }
            &.swiper-slide-next, &.swiper-slide-prev {
                opacity: .5;
            }
        }
        .swiper-button-prev {
            background: url('https://s20.lgstatic.com/growth/activity/20210701/1625110169782.png') no-repeat center;
            background-size: 100% 100%;
            width: 44PX;
            height: 93PX;
            transform: rotate(180deg);
            margin-top: -80PX;
        }
        .swiper-button-next {
            background: url('https://s20.lgstatic.com/growth/activity/20210701/1625110169782.png') no-repeat center;
            background-size: 100% 100%;
            width: 44PX;
            height: 93PX;
            margin-top: -80PX;
        }
    }
}
.section-5 {
    width: 1120PX;
    margin: 0 auto 120PX;
    .title {
        width: 100%;
        height: 68PX;
        background: url('https://s20.lgstatic.com/growth/activity/20210701/1625110782424.png') no-repeat center;
        background-size: 100% 100%;
        text-align: center;
        line-height: 68PX;
        font-size: 22PX;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #FFFFFF;
    }
    .main {
        background-color: #fff;
        box-shadow: 5PX 5PX 20PX 0PX rgba(104, 98, 198, 0.14);
        border-radius: 22PX;
        box-sizing: border-box;
        position: relative;
        // padding: 40PX 32PX;
        .m-title {
            padding-top: 30PX;
            font-size: 28PX;
            font-family: SourceHanSansSC-Medium, SourceHanSansSC;
            font-weight: 400;
            color: #303032;
            text-align: center;
        }
        .main-icon {
            width: 688PX;
            height: 2PX;
            display: block;
            margin: 8PX auto 0;
            background: linear-gradient(90deg,#FFFFFF 0%, #464752 50%,#FFFFFF 100%);
        }
        .m-flex {
            display: flex;
            font-size: 14PX;
            color: #6469A7;
            padding: 35PX 60PX;
            border-radius: 8PX;
            .left {
                width: 600PX;
            }
            .right {
                flex:1;
            }
            .m-t {
                font-weight: bold;
                padding-bottom: 11PX;
                color: #36363C;
            }
            .m-t-icon {
                width: 312PX;
                height: 1PX;
                background-color: #848487;
            }
            .item {
                margin-top: 8PX;
                padding-left: 12PX;
                position: relative;
                color: #49494B;
                &::after {
                    position: absolute;
                    content: '';
                    left: 0PX;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 4PX;
                    height: 4PX;
                    border-radius: 50%;
                    background: #707070;
                }
            }
        }
        .jumpFnbox {
            position: absolute;
            left: 50%;
            bottom: -50PX;
            transform: translate(-50%);
            z-index: 9;
            width: 400PX;
            height: 86PX;
        }
        .jumpFn {
            background-color:transparent;
            border: none;
            width: 400PX;
            height: 86PX;
            transition: all 0.6s;    //设置动画执行的时间为0.6s
            cursor: pointer;
            position: relative;
            &:hover {
                transform: scale(1.05);
            }
            img {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
            }
            span {
                width: 100%;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                font-weight: normal;
                font-size: 30PX;
                color: #fff;
                font-family: 'SourceHanSansCN-Bold', 'SourceHanSansCN';
                font-weight: bold;
                letter-spacing: 5PX;
            }
            
        }
    }
    
}
/deep/ .el-tabs {
    width: 1120PX;
    margin: 0PX auto;
    box-sizing: border-box;
    padding: 30PX 20PX;
    .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
        height: 47PX;
    }
    .el-tabs__nav-scroll {
        width: 1000PX;
        margin: 0px auto;
    }
    .el-tabs__item {
        line-height: 47PX;
        text-align: center;
        width: 130PX;
        height: 47PX;
        font-size: 16PX;
        font-family: SourceHanSansSC-Bold, SourceHanSansSC;
        font-weight: bold;
        color: #3D3D3D;
    }
    .el-tabs__nav-wrap::after{
        background-color: transparent;
    }
    .el-tabs__nav-prev {
        top: 50%;
        color: #3D3D3D;
        font-weight: 500;
        font-size: 30PX;
        transform: translateY(-50%);
        z-index: 99;
    }
    .el-tabs__nav-next {
        top: 50%;
        color: #3D3D3D;
        font-weight: 500;
        font-size: 30PX;
        transform: translateY(-50%);
        z-index: 99;
    }
    .el-tabs__active-bar {
        background-color: transparent;
    }
    .el-tabs__item.is-active {
        border-radius: 50PX;
        padding: 0;
        background: linear-gradient(151deg, #FFB317 0%, #FF613A 100%);
        color: #fff;
    }
}
.section-6 {
    width: 1197PX;
    height: 391PX;
    margin: 0 auto;
    background: url('https://s21.lgstatic.com/growth/activity/20210701/1625123696152.png') no-repeat center;
    background-size: 100% 100%;
    position: relative;
    .text {
        position: absolute;
        font-size: 22PX;
        color: #fff;
    }
    .t1 {
        left: 68PX;
        top: 15PX;
    }
    .t2 {
        left: 68PX;
        top: 117PX;
    }
    .t3 {
        left: 68PX;
        top: 218PX;
    }
    .t4 {
        left: 68PX;
        top: 320PX;
    }
    .t5 {
        right: 68PX;
        top: 15PX;
    }
    .t6 {
        right: 68PX;
        top: 117PX;
    }
    .t7 {
        right: 68PX;
        top: 218PX;
    }
    .t8 {
        right: 68PX;
        top: 320PX;
    }
}
.section-7 {
    width: 1200PX;
    margin: 0 auto;
    /deep/ .sw-wrap {
        width: 1100PX;
        padding-bottom: 40PX;
        .swiper-slide {
            width: 900PX;
            img {
                display: block;
                margin: 0 auto;
                width: 900PX;
            }
        }
        .swiper-pagination {
            bottom: 0PX;
        }
        .swiper-pagination-bullet{
            width: 10PX;
            height: 10PX;
            background: #757575;
            border-radius: 50%;
            opacity: .4;
            &-active{
                border-radius: 10PX;
                width: 22PX;
                background: #757575;
                opacity: 1;
            }
        }
        .swiper-button-prev {
            background: url('https://s20.lgstatic.com/growth/activity/20210701/1625123251674.png') no-repeat center;
            background-size: 100% 100%;
            width: 56PX;
            height: 56PX;
        }
        .swiper-button-next {
            background: url('https://s20.lgstatic.com/growth/activity/20210701/1625123238574.png') no-repeat center;
            background-size: 100% 100%;
            width: 56PX;
            height: 56PX;

        }
    }
}
.section-8 {
    margin: 0 auto;
    width: 1140PX;
    height: 672PX;
    display: flex;
    .left {
        width: 550PX;
        height: 672PX;
        background-color: #fff;
        margin-right: 40PX;
        border-radius: 24PX 24PX 16PX 16PX;
    }
    .right {
        width: 550PX;
        height: 672PX;
        background-color: #fff;
        border-radius: 24PX 24PX 16PX 16PX;
    }
    .t1 {
        background: url('https://s21.lgstatic.com/growth/activity/20210701/1625124086081.png') no-repeat center;
        background-size: 100% 100%;
    }
    .t2 {
        background: url('https://s21.lgstatic.com/growth/activity/20210701/1625124107315.png') no-repeat center;
        background-size: 100% 100%;
    }
    .title {
        width: 100%;
        height: 106PX;
        text-align: center;
        line-height: 106PX;
        font-size: 30PX;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #FCFFFE;
        text-shadow: 0PX 2PX 4PX #9A825B;
    }
    .main {
        width: 100%;
        padding: 45PX 40PX 0 25PX;
        box-sizing: border-box;
        .m-t {
            position: relative;
            font-size: 22PX;
            font-family: 'SourceHanSansCN-Bold', 'SourceHanSansCN';
            font-weight: bold;
            color: #353535;
            padding-left: 15PX;
            margin-bottom: 16PX;
            &::before {
                content: '';
                width: 5PX;
                height: 21PX;
                background: url('https://s21.lgstatic.com/growth/activity/20210701/1625124686079.png') no-repeat center;
                background-size: 100% 100%;
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
        .m-desc {
            font-size: 18PX;
            font-family: 'SourceHanSansCN-Regular', 'SourceHanSansCN';
            font-weight: 400;
            color: #353535;
            padding-left: 15PX;
            margin-bottom: 50PX;
            line-height: 28PX;
        }
    }
}
.section-9 {
    width: 1200PX;
    margin: 0 auto;
    .r-main {
        margin: 0 auto;
        background: url('https://s21.lgstatic.com/growth/activity/20210701/1625127250706.png') no-repeat center;
        background-size: 100% 100%;
        width: 960PX;
        height: 526PX;
        box-shadow: 5PX 5PX 20PX 0PX rgba(104, 98, 198, 0.14);
        padding-top: 1PX;
    }
}
/deep/ .range_list {
    margin-top: 90PX;
    width: 880PX;
    height: 400PX;
    .swiper-slide {
        width: 900PX;
        height: 80PX;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1PX rgba(151, 151, 151, 1) dashed;
        .company {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
            .company-img {
                width: 100PX;
                display: block;
            }
        }
        .name {
            flex: 1;
            font-size: 20PX;
            color: #666;
            text-align: center;
            line-height:80PX;
        }
        .range {
            flex: 1;
            font-size: 20PX;
            color: #666;
            text-align: center;
            line-height: 80PX;
        }
        .course_name {
            flex: 1;
            font-size: 20PX;
            font-weight: 500;
            color: #FF0000;
            text-align: center;
            line-height: 80PX;
        }
    }
}
/deep/ .rank-list .swiper-wrapper {
  -webkit-transition-timing-function: linear;    /*之前是ease-out*/
  -moz-transition-timing-function: linear;
  -ms-transition-timing-function: linear;
  -o-transition-timing-function: linear;
  transition-timing-function: linear;
  margin: 0 auto;
}
.section-10 {
    width: 100%;
    min-width: 1200PX;
    background: url('https://s20.lgstatic.com/growth/activity/20210701/1625127522155.png') no-repeat center;
    background-size: 100% 100%;
    height: 1242PX;
    margin-top: 80PX;
    padding-top: 1PX;
    .img {
        width: 905PX;
        height: 787PX;
        display: block;
        margin: 0 auto;
    }
}
.footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 130PX;
    min-width: 1200PX;
    left: 50%;
    transform: translate(-50%);
    z-index: 999;
    background-color: #F0DAB3;
    .footer-btn {
        position: relative;
        width: 1200PX;
        height: 130PX;
        display: block;
        margin: 0 auto;
        background-color:transparent;
        border: none;
        .text {
            text-align: left;
            font-size: 36PX;
            font-family: 'SourceHanSansCN-Bold', 'SourceHanSansCN';
            font-weight: bold;
            color: #3B2A0C;
            line-height: 130PX;
        }
        .i-bs {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 400PX;
            height: 86PX;
        }
        .img-box {
            position: relative;
            width: 400PX;
            height: 86PX;
            transition: all 0.6s;    //设置动画执行的时间为0.6s
            cursor: pointer;
            &:hover {
                transform: scale(1.05);
            }
            .img {
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                display: block;
                
            }
            .i_t {
                position: absolute;
                font-weight: normal;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                font-size: 30PX;
                font-family: 'SourceHanSansCN-Bold', 'SourceHanSansCN';
                font-weight: bold;
                color: #FFFFFF;
                letter-spacing: 5px;
            }
        }
    }
}
</style>